export const CITY = require('./city.config')
export const ROOT_REQUEST = require(`./env/${process.env.NODE_ENV}`)
 